import {gql} from '@apollo/client'

export const GET_KANBAN_WORKFLOWS = gql`
  query KanbanWorkflows($groupAssignmentId: ID, $includeArchived: Boolean) {
    kanbanWorkflows(
      groupAssignmentId: $groupAssignmentId
      includeArchived: $includeArchived
    ) {
      id
      name
      description
      color
      icon
      isArchived
      visibility
      groupAssignments {
        edges {
          node {
            id
            name
          }
        }
      }
      sharedWith {
        edges {
          node {
            id
            firstName
            lastName
            email
          }
        }
      }
    }
  }
`

export const GET_KANBAN_STAGES = gql`
  query KanbanStages($workflowId: ID!) {
    kanbanStages(workflowId: $workflowId) {
      id
      name
      description
      position
      color
      wipLimit
      isClosedState
    }
  }
`

export const GET_KANBAN_TASKS = gql`
  query KanbanTasks($workflowId: ID, $groupAssignmentId: ID, $onlyParticipating: Boolean) {
    kanbanTasks(
      workflowId: $workflowId
      groupAssignmentId: $groupAssignmentId
      onlyParticipating: $onlyParticipating
    ) {
      id
      title
      description
      position
      tagColor
      labelText
      priority
      dueDate
      createdAt
      isCompleted
      completedAt
      isArchived
      archivedAt
      checklistItems {
        id
        title
        isCompleted
      }
      workflow {
        id
        name
      }
      stage {
        id
        name
      }
      assignmentGroup {
        id
        name
      }
      creator {
        id
        firstName
        lastName
        email
      }
      participants {
        id
        role
        user {
          id
          firstName
          lastName
          email
        }
      }
      assignee {
        id
        firstName
        lastName
        email
      }
      isArchived
      archivedAt
    }
  }
`

export const GET_KANBAN_TASK_ATTACHMENTS = gql`
  query KanbanTask($id: ID!) {
    kanbanTask(id: $id) {
      id
      title
      attachments {
        id
        originalName
        description
        fileSize
        contentType
        file
        createdAt
        uploadedBy {
          id
          firstName
          lastName
        }
      }
    }
  }
`

export const GET_KANBAN_TASK_DETAIL = gql`
  query KanbanTaskDetail($id: ID!) {
    kanbanTask(id: $id) {
      id
      title
      description
      dueDate
      tagColor
      labelText
      priority
      isCompleted
      completedAt
      isArchived
      archivedAt
      archivedAt
      createdAt
      workflow {
        id
      }
      stage {
        id
        name
      }
      assignmentGroup {
        id
        name
      }
      assignee {
        id
        firstName
        lastName
        email
      }
      creator {
        id
        firstName
        lastName
        email
      }
      checklistItems {
        id
        title
        isCompleted
      }
      attachments {
        id
        originalName
        description
        file
        contentType
        createdAt
        uploadedBy {
          id
          firstName
          lastName
        }
      }
      comments {
        id
        body
        createdAt
        isInternal
        author {
          id
          firstName
          lastName
          email
        }
      }
      participants {
        id
        role
        user {
          id
          firstName
          lastName
          email
        }
      }
    }
  }
`
